import api from "@/lib/Api";

export const getExpensesByProductId = async (
  product_id,
  start_date,
  end_date
) => {
  try {
    const queryRoute = `/expenses?product_id=${product_id}&start_date=${start_date}&end_date=${end_date}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getDistinctProduct = async () => {
  try {
    const queryRoute = `/expenses/products/distinct`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const getExpenses = async (
  product_id = null,
  start_date = null,
  end_date = null
) => {
  try {
    const queryRoute = `/expenses?product_id=${product_id}&start_date=${start_date}&end_date=${end_date}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getExpensesById = async (id) => {
  try {
    const queryRoute = `/expenses/${id}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const updateExpenses = async (id, body) => {
  try {
    const queryRoute = `/expenses/${id}`;

    const fetchRes = api.axios.put(queryRoute, body);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const createExpenses = async (body) => {
  try {
    const queryRoute = `/expenses`;

    const fetchRes = api.axios.post(queryRoute, body);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const downloadAttachment = async (body) => {
  try {
    const queryRoute = `/expenses/download`;

    const fetchRes = api.axios.post(queryRoute, body);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const downloadExpensesExcel = async (start_date, end_date) => {
  try {
    const queryRoute = "/expenses/excel";
    const body = {
      start_date,
      end_date,
    };
    const fetchRes = api.axios.post(queryRoute, body, {
      responseType: "blob",
    });
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
